import { render, staticRenderFns } from "./Experience.vue?vue&type=template&id=84a9c8a2&scoped=true"
import script from "./Experience.vue?vue&type=script&lang=js"
export * from "./Experience.vue?vue&type=script&lang=js"
import style0 from "./Experience.vue?vue&type=style&index=0&id=84a9c8a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a9c8a2",
  null
  
)

export default component.exports